import { Injectable } from '@angular/core';

/** The lg breakpoint, matching Tailwind's, so TS and CSS agree on "desktop". */
const DESKTOP_MIN_WIDTH = 1024;

/**
 * What survives of the old Poseidon LayoutService: one query.
 *
 * Everything else it carried (menu modes, colour schemes, a config panel, a theme
 * switcher, scale) was never reachable at runtime. Read at call time, not cached: it is
 * used to pick page sizes and column visibility, not to drive a live layout.
 */
@Injectable({ providedIn: 'root' })
export class LayoutService {
  isDesktop(): boolean {
    return window.innerWidth >= DESKTOP_MIN_WIDTH;
  }
}
